<template lang="pug">
  .mytask_page_container
    .mytask_main_container
      p.my_task_header_style 我的任务
      .my_task_table_container
        <el-table ref='multipleTable' row-class-name="row-active" :data="tableData"  @selection-change="wordListSelected" :header-cell-style="getRowClass" style="width: 900px" :row-style="rowStyle"  @cell-mouse-enter="handleMouseEnter" @cell-mouse-leave="handleMouseOut" tooltip-effect="light">
          //- <el-table-column width="22" class-name="check-column">
          //-   <template slot-scope="scope">
          //-     <el-checkbox v-model="scope.row.checked" :disabled="disabledSelected.indexOf(scope.row.status) > -1" @change="handleCheckboxEvent(scope.row)"></el-checkbox>
          //-   </template>
          //- </el-table-column>
          <el-table-column width="24" type="selection" class-name="check-column" :selectable="isCanSelect"></el-table-column>
          <el-table-column class="column-for-file-name" prop="name" label="文件名" width="280">
            <template slot-scope="scope">
              <el-popover popper-class="task-file-name"  width="280" offset=0 transition="none" placement="bottom-start" trigger="hover" @after-enter="onPopoverEnter()" :disabled="scope.row.name.length < 17" >
                <div>{{scope.row.name}}</div>
                <span slot="reference" :class="{disabledText: disabledStatus.indexOf(scope.row.status) > -1 || scope.row.statusCode === 6}" class="file-name-style hover-style ellipsis" @click="onCheckingTransClick(scope.row.flownumber, scope.row.language, scope.row.langFrom, scope.row.langTo, scope.row.name, scope.row.status, scope.row.statusCode, scope.row.vocabInfo)">{{scope.row.name}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="pages" label="页数" width="60">
            <template slot-scope="scope">
                <p v-html='scope.row.pages' :class="{disabledText: disabledStatus.indexOf(scope.row.status) > -1}"></p>
            </template>
          </el-table-column>
          <el-table-column prop="language" label="翻译语言" width="90">
            <template slot-scope="scope">
                <p v-html='scope.row.language' :class="{disabledText: disabledStatus.indexOf(scope.row.status) > -1}"></p>
            </template>
          </el-table-column>
          <el-table-column prop="vocabInfo" label="关联术语库"  width="120">
            <template slot-scope="scope">
              <el-popover popper-class="vocabInfo" transition=" "   placement="bottom" trigger="hover" @after-enter="onPopoverEnter()" :disabled="scope.row.vocabStatus !== 0">
                <div>该词表已被删除</div>
                <p slot="reference" :class="{disabledText: disabledStatus.indexOf(scope.row.status) > -1 || scope.row.vocabStatus === 0}" class="hover-style" @click="editFile({name: scope.row.vocabInfo, space_id: scope.row.spaceId, file_meta_id: scope.row.fileMateId, vocabStatus: scope.row.vocabStatus, langFrom: scope.row.langFrom, langTo: scope.row.langTo})">{{scope.row.vocabInfo}}</p>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170">
          </el-table-column>
          //- <el-table-column prop="createTime" label="创建时间" width="170">
          //-   <template slot-scope="scope">
          //-       <p v-html='scope.row.createTime' :class="{disabledText: disabledStatus.indexOf(scope.row.status) > -1}"></p>
          //-   </template>
          //- </el-table-column>
          <el-table-column prop="status" label="任务进程" width="90">
            <template slot-scope="scope">
              <el-progress class="progress-bar" v-if="scope.row.statusCode === 1" :percentage="scope.row.progress" color="#2962FF" :stroke-width="4" :show-text="false"></el-progress>
              <p v-if="scope.row.statusCode !== 1" v-html="scope.row.status" :class="{disabledText: disabledStatus.indexOf(scope.row.status) > -1}"></p>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="60">
            <template slot-scope="scope">
              <div class="operation-btn-container">
                <div class="icon-container">
                  <span id="disabled_download" v-if="scope.row.status === '进行中'"  class="operationIconStyle" ></span>
                  <span id="disabled_delete" v-if="scope.row.status === '进行中'" class="operationIconStyle" ></span>
                  //- <span id="downloadTransId" :class="{hideIcon: scope.row.status === '进行中', 'visibility-hidden': chargeStatus.indexOf(scope.row.status) > -1}" class="operationIconStyle" @click="onDownloadClick(scope.row.name,scope.row.flownumber, 'word')"></span>
                  <span id="downloadTransId" :class="{hideIcon: scope.row.status === '进行中', 'visibility-hidden': chargeStatus.indexOf(scope.row.status) > -1}" class="operationIconStyle" @click="handleOnDownloadClick(scope.row.name,scope.row.flownumber, scope.row)"></span>
                  <span id="deleteTransId" :class="{hideIcon: scope.row.status === '进行中'}" class="operationIconStyle"  @click="onDeleteClick(scope.row.flownumber)"></span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      .fixed_bottom_container
        .fixed_center_container
          .left_bottom_container
            //- img(src="../assets/ic_ArrowLeft_normal.png" class="arrow-btn-style" @click="onLeftArrowClick")
            <span id="left-arrow-icon" :class="['arrow-btn-style', {'left-not-change-page': pageId === 1}]"  class="arrow-btn-style" @click="onLeftArrowClick"></span>
            <input placeholder="" v-model="pageId" class="page-number-input-box" @change="onPageInputboxChange" />
            div.slash_style /
            div.total_page_number {{totalPageNumber}}
            //- img(src="../assets/ic_ArrowRight_normal.png" class="arrow-btn-style" @click="onRightArrowClick")
            <span id="right-arrow-icon" :class="['arrow-btn-style', {'right-not-change-page': pageId === totalPageNumber}]"  @click="onRightArrowClick"></span>
          .right_bottom_container
            .radio_container
              //- <el-radio v-model="exportType" label="pdf" class="mytask-radio-style" :disabled="halfDoneList.length !== 0 ||isDownloadDisabled">pdf(不可编辑)</el-radio>
              //- <el-radio v-model="exportType" label="word" class="mytask-radio-style" :disabled="isDownloadDisabled">word(可编辑)</el-radio>
            .btn_container
              //- <el-button class="mytask-btn-style mytask-download-btn" :disabled="isDownload" @click="onDownloadClick(selectedNameList, selectedDownloadList, exportType)" round>下载</el-button>
              <el-button class="mytask-btn-style mytask-download-btn" :disabled="isDownload" @click="handleOnDownloadClick(selectedNameList, selectedDownloadList)" round>下载</el-button>
              div.btn_divider
              <el-button class="mytask-btn-style mytask-delete-btn" :disabled="isDownloadDisabled" @click="deleteInBatch()" round>删除</el-button>

    <PopTips/>
    FeedBack
    DownloadType(
      v-if="isShowDownloadType"
      :isShowHightLightProp="isShowHightLightProp"
      :isDisablePDF="isDisablePDF"
      :fileType="fileType"
      @okCb="onDownloadClickOkCb"
      @close="closeDownloadType"
    )
    //- TransMyTaskPopup(ref="TransMyTaskPopup" :isMyTaskPopupShow="isMyTaskPopupShow" :myTaskStatusCode="myTaskStatusCode" :selectedDownloadList="selectedDownloadList" v-on:hideMyTaskPopup="hideMyTaskPopup" v-on:hideMyTaskPopupDownloadPart="hideMyTaskPopupDownloadPart" v-on:startOver="startOver")

</template>
<style lang="scss" scoped>
@import './myTask.scss';
</style>
<script>
import { mapActions } from 'vuex'
import $docsTrans from '../../services/trans/index.js'
import _ from 'lodash'
import PopTips from '../../components/PopupTips'
import FeedBack from '../../components/FeedBack'
import ProcessBar from '@/components/processBar'
import * as common from '../../utils/common'
import DownloadType from '../../components/userDict/downloadType'
var timer
export default {
  name: 'myTask',
  data() {
    return {
      userName: '',
      tableData: [],
      exportType: 'origin',
      pageId: '',
      totalPageNumber: '',
      pageSize: 10,
      isDownloadDisabled: true,
      isDownload: true,
      selectedDownloadList: [], // 之前分页选择的列表
      allSelectedTableRowList: [], // 包含之前选中的的table的完整row信息
      selectedDownloadTempAry: [],
      selectedNameList: [],
      filesSelectedToDownload: 0,
      completionStatus: ['已完成', '失败', '已欠费'],
      noChargeStatus: ['已完成', '失败'],
      chargeStatus: ['已欠费', '失败'],
      disabledStatus: ['进行中', '失败', '已欠费'],
      disabledSelected: ['进行中'],
      resDataLength: 0,
      transCompleteNumber: 0,
      pendingObjArr: [],
      oneTimerFlag: true,
      maxCheckingTime: 20,
      checkCounter: 0,
      currentDownloadBtn: null,
      // 设置弹窗的参数
      isMyTaskPopupShow: false,
      myTaskStatusCode: 3,
      halfDoneList: [],
      toggleRowSelectionFlag: false, // 默认给数据checked回显的时候  禁止触发手动的 selection-change事件
      isShowDownloadType: false,
      isShowHightLightProp: false, //下载选择类型弹框是否有高亮选项 （如果已选列表的statuscode有关联术语库的则有高亮选项）
      fileType: '', // 文件类型
      tmpDownloadName: '', // 为了给列表和真正的下载之间传递值
      tmpDownloadFlownumber: '', // 为了给列表和真正的下载之间传递值
      isDisablePDF: true //下载选择类型弹框是否禁用pdf （如果已选列表的statuscode有不等于6的则不禁用pdf）
    }
  },
  created() {
    this.$trackSDK._trackEvent('登录主页', '展示页面“我的任务”')
    this.setTab('mytask')
  },
  mounted() {
    this.fetchData()
  },
  destroyed() {
    this.$cookies.remove('CURPAGENUMBER')
  },
  methods: {
    ...mapActions('doctrans', [
      'setCurrentProcessFile',
      'setPopTipsStatus',
      'setPopTipsContent',
      'setSucIconStatus',
      'setBase64ListOriginal',
      'setBase64ListTranslated',
      'setListOriginal'
    ]),
    ...mapActions('headTop', ['setTab']),
    ...mapActions('userDict', ['setFileInfo']),
    // 关闭下载类型弹框
    closeDownloadType() {
      this.isShowDownloadType = false
      this.downloadFileType = 'origin'
      this.isHightLight = true
      this.isDisablePDF = true
      this.isShowHightLightProp = false
    },
    // 选中发生改变
    wordListSelected(val) {
      if (this.toggleRowSelectionFlag) return
      // 当前table全量的flownumber列表
      let tableDataFlownumberList = this.tableData.map(i => i.flownumber)
      //tableData的checked变为未选中
      this.tableData.forEach(item => (item.checked = false))
      //所有选中的数组中清除之前table选中存入的数据
      this.selectedDownloadList = this.selectedDownloadList.filter(item => !tableDataFlownumberList.includes(item))
      this.allSelectedTableRowList = this.allSelectedTableRowList.filter(
        item => !tableDataFlownumberList.includes(item.flownumber)
      )
      this.selectedDownloadTempAry = this.selectedDownloadTempAry.filter(
        item => !tableDataFlownumberList.includes(item.flownumber)
      )
      this.selectedNameList = []
      this.filesSelectedToDownload = this.selectedDownloadList.length // 基数为前几页的选中数量
      // this.isDownload = true
      this.checkingDownloadBtnStatus()
      val.forEach(item => {
        item.checked = true
        this.handleCheckboxEvent(item)
        this.allSelectedTableRowList.push(item)
      })
      if (val.length === 0) this.maintainDownloadList()
    },
    // 判断当前checkbox是否可用
    isCanSelect(row, index) {
      return this.disabledSelected.indexOf(row.status) <= -1
    },
    async onMessage() {
      return new Promise((res, rej) => {
        this.$confirm('删除后不可恢复，是否继续删除？', '删除提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          customClass: 'delete-warnig-msg'
        })
          .then(() => {
            res(true)
          })
          .catch(action => {
            res(false)
          })
      })
    },
    rowStyle({ row, rowIndex }) {
      if (row.checked === true) {
        return 'background:rgba(41,98,255,0.08);'
      } else {
        return ''
      }
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'font-size:13px;font-family:PingFangSC-Semibold, sans-serif;font-weight:600;color:rgba(144,146,153,1);line-height:15px;'
      } else {
        return 'font-size:13px;font-family:PingFangSC-Regular, sans-serif;font-weight:400;color:rgba(46,47,51,1);line-height:13px;'
      }
    },
    fetchData() {
      const _this = this
      this.toggleRowSelectionFlag = true
      let resData = []
      _this.pendingObjArr = []
      const cookiesObj = this.$cookies.get('CURPAGENUMBER') || {}
      this.totalPageNumber = cookiesObj.totalPageNumber || ''
      this.pageId = cookiesObj.pageId || _this.pageId

      $docsTrans.checkTransJobs(_this.pageId, _this.pageSize).then(data => {
        if (data.errorCode === '0') {
          resData = data.list || []
          _this.resDataLength = resData.length || 0
          _this.totalPageNumber = data.pages === 0 ? 1 : data.pages
          _this.pageId = data.pageId
          _this.setPageNumberCookies({
            pageId: _this.pageId,
            totalPageNumber: _this.totalPageNumber
          })
          // 后台数据返回后,手动添加一个checked属性控制选中与否
          resData.forEach((item, index, arr) => {
            if (_this.selectedDownloadList.indexOf(item.flownumber) > -1) {
              arr[index].checked = true
            } else {
              arr[index].checked = false
            }
            // -1 就是不在完成或者失败的状态，那么就是进行中或者新任务
            if (_this.completionStatus.indexOf(item.status) === -1) {
              let pendingObj = {
                flownumber: item.flownumber,
                status: item.status
              }
              _this.pendingObjArr.push(pendingObj)
            }
            item.createTime = common.formatTime(item.createTime)
          })
          _this.tableData = resData
          // 切回的时候 设置默认选中
          _this.$nextTick(() => {
            resData.forEach((item, index) => _this.$refs.multipleTable.toggleRowSelection(item, item.checked))
            _this.toggleRowSelectionFlag = false
          })
          if (_this.tableData.length === 0) {
            _this.isDownloadDisabled = true
            _this.isDownload = true
          } else {
            // 检查底部下载栏的状态
            _this.checkingDownloadBtnStatus()
          }

          if (_this.oneTimerFlag && _this.pendingObjArr.length > 0) {
            _this.startTimerToRetrieveData()
            // 这个设计的目的是仅仅起一个TIMER
            _this.oneTimerFlag = false
          } else if (_this.pendingObjArr.length === 0) {
            _this.clearTimerToRetrieveData()
          } else if (_this.checkCounter >= _this.maxCheckingTime) {
            _this.clearTimerToRetrieveData()
          }
        } else if (data.errorCode === '111') {
          // common.goToLogin('my-task')
        } else if (data.errorCode === '401') {
          _this.handleShowPopTips('账户已经欠费停止')
        } else if (data.errorCode === '19001') {
          _this.handleShowPopTips('余额不足')
        } else {
          _this.handleShowPopTips(data.errorMessage)
        }
      })
    },
    handleShowPopTips(content) {
      this.setPopTipsContent(content)
      this.setPopTipsStatus(true)
      this.setSucIconStatus(false)
      setTimeout(() => {
        this.setPopTipsStatus(false)
      }, 2000)
    },
    startTimerToRetrieveData() {
      const _this = this
      timer = setInterval(function() {
        _this.fetchData()
        _this.checkCounter = _this.checkCounter + 1
      }, 5000)
    },
    clearTimerToRetrieveData() {
      clearInterval(timer)
    },
    handleCheckboxEvent(row) {
      // 控制下方下载栏是否置灰
      if (row.checked) {
        this.filesSelectedToDownload = this.filesSelectedToDownload + 1
        this.isDownloadDisabled = false
      } else {
        this.filesSelectedToDownload = this.filesSelectedToDownload - 1
        this.checkingDownloadBtnStatus()
      }
      // 动态维护一下需要下载数组
      this.maintainDownloadList(row.checked, row.flownumber, row.name, row.statusCode, row.status)
    },
    maintainDownloadList(status, flownumber, name, statusCode, fileStatus) {
      const _this = this
      // console.log('this.selectedDownloadList.length', this.selectedDownloadList.length)
      if (status) {
        this.selectedDownloadList.push(flownumber)
        this.selectedNameList.push(name)
        let tempObj = { flownumber, fileStatus }
        _this.selectedDownloadTempAry.push(tempObj)
        if (fileStatus === '已完成') {
          _this.isDownload = false
        }
        if (statusCode === 6) {
          _this.halfDoneList.push(flownumber)
        }
      } else {
        this.selectedDownloadList = this.selectedDownloadList.filter(function(item) {
          return item !== flownumber
        })
        this.selectedDownloadTempAry = this.selectedDownloadTempAry.filter(function(item) {
          return item.flownumber !== flownumber
        })
        let selectedSuccessFilesAry = this.selectedDownloadTempAry.filter(function(item) {
          return item.fileStatus === '已完成'
        })

        if (selectedSuccessFilesAry.length === 0 && this.selectedDownloadList.length === 0) {
          _this.isDownload = true
        }

        this.halfDoneList = this.halfDoneList.filter(function(item) {
          return item !== flownumber
        })
        this.selectedNameList = this.selectedNameList.filter(function(item) {
          return item !== name
        })
      }
    },
    checkingDownloadBtnStatus() {
      if (this.filesSelectedToDownload > 0) {
        this.isDownloadDisabled = false
      } else {
        this.isDownloadDisabled = true
      }
    },
    editFile(data = {}) {
      if (data.vocabStatus === 0) return
      this.setFileInfo(data)
      this.$router.push({ path: '/edit-wordlist' })
      sessionStorage.removeItem('CURRENTPAGENUMBER')
    },
    onCheckingTransClick(flownumber, language, langFrom, langTo, name, status, statusCode = null, vocabInfo = null) {
      this.$trackSDK._trackEvent('我的任务页面', '单击某文件名')
      const _this = this
      if (_this.disabledStatus.indexOf(status) > -1 || _this.chargeStatus.indexOf(status) > -1 || statusCode === 6) {
        return
      }

      let obj = {
        language,
        langFrom,
        langTo,
        name: name,
        vocabInfo: vocabInfo || ''
      }
      this.setCurrentProcessFile(obj)
      const fileType = name.substr(name.lastIndexOf('.') + 1).toLowerCase()
      const isShowHightLightProp = !!vocabInfo && !['ppt', 'pptx'].includes(fileType)

      sessionStorage.setItem('ID_FLOWNUMBER', flownumber)
      sessionStorage.setItem('STATUSCODE', statusCode)
      sessionStorage.setItem('HAS_VOCABINFO', isShowHightLightProp)
      sessionStorage.setItem('FILE_TYPE', fileType)
      this.setBase64ListOriginal([])
      this.setBase64ListTranslated([])
      this.setListOriginal([])
      this.$router.push({ path: '/task-detail' })
    },
    handleOnDownloadClick(name, flownumber, rowData) {
      // 批量下载前先检验勾选列表中是否都是已完成状态，不是则弹窗提示
      let isAllSuccessed = this.selectedDownloadTempAry.filter(function(item) {
        return item.fileStatus !== '已完成'
      })
      if (isAllSuccessed.length > 0) {
        this.$confirm('“失败”文档无法下载，请重新勾选', '提示', {
          confirmButtonText: '确定',
          confirmButtonClass: 'tips-confirm',
          showCancelButton: false,
          center: true,
          type: 'warning'
        })
        return
      }
      this.tmpDownloadName = name
      this.tmpDownloadFlownumber = flownumber
      if (Array.isArray(name)) {
        this.$trackSDK._trackEvent('我的任务页面', '单击批量“下载”')
        // 多选下载
        let vocabInfoListTmp = this.allSelectedTableRowList.filter(item => {
          return item.vocabInfo
        })
        let hasPDFListTmp = this.allSelectedTableRowList.filter(item => {
          return item.statusCode !== 6
        })
        this.isDisablePDF = hasPDFListTmp.length === 0
        this.isShowHightLightProp = vocabInfoListTmp.length > 0
        this.fileType = ''
      } else {
        this.$trackSDK._trackEvent('我的任务页面', '单击“下载icon”')
        // 单条下载
        this.fileType = rowData.name.substr(rowData.name.lastIndexOf('.') + 1).toLowerCase()
        this.isShowHightLightProp = !!rowData.vocabInfo && !['ppt', 'pptx'].includes(this.fileType)
        this.isDisablePDF = rowData.statusCode === 6
      }
      this.isShowDownloadType = true
    },
    onDownloadClickOkCb(downloadFileType, isHightLight) {
      this.downloadFileType = downloadFileType
      this.isHightLight = isHightLight
      this.onDownloadClick(this.tmpDownloadName, this.tmpDownloadFlownumber, this.downloadFileType, this.isHightLight)
    },
    onDownloadClick(name, flownumber, exportType, isHightLight) {
      const _this = this
      $docsTrans.downloadSelectedJob(flownumber.toString(), exportType, isHightLight).then(res => {
        this.isShowDownloadType = false
        if (res.headers['content-type'].indexOf('application/json') > -1) {
          if (res.data.errorCode === '111') {
            // common.goToLogin('my-task')
            _this.isBroken = true
          } else if (res.data.errorCode === '401') {
            _this.handleShowPopTips('账户已经欠费停止')
            _this.isBroken = true
          } else if (res.data.errorCode === '19001') {
            _this.handleShowPopTips('余额不足')
            _this.isBroken = true
          }
        } else {
          let tmpArr = res.headers['content-disposition'].split(';')
          let resFileName = tmpArr.filter(i => i.indexOf('filename=') > -1 || i.indexOf('fileName=') > -1)[0]
          let lastIdx = resFileName.lastIndexOf('.')
          let resType = resFileName.substr(lastIdx)
          _this.handleDownloadFile(res.data, name, resType)
        }
      })
      // 关闭下载弹窗
      // this.currentDownloadBtn.style.display = 'none'
    },
    handleDownloadFile(data, name, resType) {
      const blob = new Blob([data])
      let resultName = typeof name === 'object' ? name[0] : name
      let firstIdx = resultName.indexOf('.')
      let fName = resultName.substr(0, firstIdx)
      resultName = resType === '.zip' ? '有道文档翻译.zip' : `${fName}${resType}`

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(blob, resultName)
      } else {
        let a = document.createElement('a')
        document.body.appendChild(a)
        let url = window.URL.createObjectURL(blob)
        let filename = resultName
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      }
    },
    async onDeleteClick(flownumber, name) {
      this.$trackSDK._trackEvent('我的任务页面', '单击“删除icon”')
      const _this = this
      const isAllowDel = await this.onMessage()
      if (!isAllowDel) return false
      $docsTrans.removeExistingJob(flownumber).then(data => {
        if (data.errorCode === '0') {
          _this.handleShowPopTips('删除成功')
          // 当前页列表删光的时候自动转入前一页
          if (_this.tableData.length === 1) {
            this.pageId = this.pageId > 1 ? this.pageId - 1 : 1
            this.setPageNumberCookies({
              pageId: this.pageId,
              totalPageNumber: this.totalPageNumber
            })
          }
          _this.fetchData()
          _this.selectedDownloadList = _this.selectedDownloadList.filter(function(item) {
            return item !== flownumber
          })
          _this.selectedNameList = _this.selectedNameList.filter(function(item) {
            return item !== name
          })
        } else {
          _this.handleShowPopTips(data.errorMessage)
        }
      })
    },
    onAddValueClick() {
      // 弹窗
      this.isMyTaskPopupShow = true
      this.myTaskStatusCode = 3
      const aiHostUrl = this.ORIGIN
      // 打开一个窗口去充值
      window.open(`${aiHostUrl}/pay.s`, '_blank')
    },
    async deleteInBatch() {
      this.$trackSDK._trackEvent('我的任务页面', '单击批量“删除”')
      const _this = this
      const isAllowDel = await this.onMessage()
      if (!isAllowDel) return false
      _.forEach(this.selectedDownloadList, function(flownumber) {
        $docsTrans.removeExistingJob(flownumber).then(data => {
          // console.log('### onDeleteInBatch click', data)
          if (parseInt(data.errorCode) === 0) {
            _this.filesSelectedToDownload--
            if (_this.filesSelectedToDownload === 0) {
              _this.fetchData()
            }
          }
        })
      })
    },
    setPageNumberCookies(val) {
      this.$cookies.set('CURPAGENUMBER', val)
    },
    onLeftArrowClick() {
      if (this.pageId <= 1) {
        return
      }
      this.pageId = this.pageId - 1
      this.setPageNumberCookies({
        pageId: this.pageId,
        totalPageNumber: this.totalPageNumber
      })
      this.fetchData()
    },
    onRightArrowClick() {
      if (this.pageId >= this.totalPageNumber) {
        return
      }
      this.pageId = Number(this.pageId) + 1
      this.setPageNumberCookies({
        pageId: this.pageId,
        totalPageNumber: this.totalPageNumber
      })
      this.fetchData()
    },
    onPageInputboxChange($event) {
      const _this = this
      const pageToJump = Number($event.target.value)
      if (pageToJump >= _this.totalPageNumber) {
        this.pageId = _this.totalPageNumber
      } else if (pageToJump <= 1) {
        this.pageId = 1
      } else {
        this.pageId = pageToJump
      }
      this.setPageNumberCookies({
        pageId: this.pageId,
        totalPageNumber: this.totalPageNumber
      })
      this.fetchData()
    },
    onPopoverEnter() {
      // 控制当前的popover 把这个控件移动到相应的位置
      // let len = document.getElementsByClassName("el-popover el-popper").length
      // const offset = 293
      // let leftPosition = (window.screen.width - 900)/2 + offset
      // document.getElementsByClassName("el-popover el-popper")[len-1].style.left = leftPosition + "px"
    },
    handleMouseEnter(row, column, cell, event) {
      // 控制相应的按钮的显示
      // cell.parentElement.lastElementChild.children[0].children[0].children[0].style.display =
      //   'none'
      // cell.parentElement.lastElementChild.children[0].children[0].children[1].style.display =
      //   'inline-flex'
      // 明确当前的下载框
      // this.currentDownloadBtn =
      //   cell.parentElement.lastElementChild.children[0].children[0].children[2]
    },
    handleMouseOut(row, column, cell, event) {
      // cell.parentElement.lastElementChild.children[0].children[0].children[0].style.display =
      //   'inline-flex'
      // cell.parentElement.lastElementChild.children[0].children[0].children[1].style.display =
      //   'none'
      // // this.currentDownloadBtn.style.display = 'none'
      // // 控制当前的popover 让它零延迟关闭
      // let len = document.getElementsByClassName('el-popover el-popper').length
      // document.getElementsByClassName('el-popover el-popper')[
      //   len - 1
      // ].style.display = 'none'
    },

    onDownloadIconClick($event) {
      this.currentDownloadBtn.style.display = 'flex'
    },
    startOver() {
      this.$router.push({
        path: '/home'
      })
    },
    hideMyTaskPopup() {
      this.isMyTaskPopupShow = false
    },
    hideMyTaskPopupDownloadPart() {},
    goManual() {
      this.$router.push({ name: 'manual' })
    }
  },
  components: {
    PopTips,
    ProcessBar,
    DownloadType,
    FeedBack
  }
}
</script>

<style lang="scss">
.mytask-btn-style {
  width: 64px;
  height: 28px;
  border-radius: 16px;
  margin: auto 0px;
  &.mytask-download-btn {
    border: 1px solid $normalC;
    span {
      color: $normalC;
    }
  }
  &.is-disabled,
  &.is-disabled:hover {
    background: #ebecf0;
    border: 0;
    span {
      color: #c0c4cc;
    }
  }
}

.el-table--enable-row-hover .el-table__body tr:hover > td .hover-style {
  color: #2962ff;
  cursor: pointer;
  &.disabledText {
    color: #abadb3;
    cursor: not-allowed;
  }
}
.el-button--primary.tips-confirm {
  background: #2962ff !important;
  border-color: #2962ff !important;
  color: #fff !important;
}
.el-button--primary.tips-confirm:hover {
  background: #2354db !important;
  border-color: #2354db !important;
  color: #fff !important;
}
.my_task_table_container .el-table .cell {
  height: 44px;
  line-height: 44px;
}
.my_task_table_container {
  .el-table__header-wrapper {
    margin-bottom: 12px;
  }
  .el-table {
    td {
      padding: 0;
      height: 48px;
    }
    td {
      border-bottom: 0;
    }
    &::before {
      height: 0;
    }
  }
  .el-table__empty-block {
    margin-top: 226px;
  }
}
.task-file-name {
  &.el-popover {
    font-size: 12px !important;
    line-height: 18px !important;
    border: 1px solid #ebecf0 !important;
    margin-top: -7px;
    // margin-top: -40px;
    // -webkit-transform: translateX(-130px);
    // transform: translateX(-130px);
    left: 30% !important;
  }
  .popper__arrow {
    // display: none;
    left: 20% !important;
  }
}
.vocabInfo {
  &.el-popover {
    min-width: 50px;
    font-size: 12px !important;
    line-height: 18px !important;
    border: 1px solid #ebecf0 !important;
    margin-top: -7px;
    -webkit-transform: translateX(10px);
    transform: translateX(10px);
    // &.word-popver {
    //   left: 60%!important
    // }
    // margin-top: -40px;
    // -webkit-transform: translateX(-70px);
    // transform: translateX(-70px);
    // border: 1px solid #ebecf0 !important;
    // -webkit-transform: translate(50px, -20px);
    // transform: translate(50px, -20px);
    // left: 41% !important;
  }
  .popper__arrow {
    left: 20% !important;
    // display: none;
    // transform: translateX(-50px);
  }
}
.el-message-box__wrapper {
  .delete-warnig-msg {
    &.el-message-box {
      width: 400px;
      padding-bottom: 24px;
      .el-message-box__title {
        span {
          @include fontStyle(18px, 600, #2e2f33, 22px, 'PingFangSC-Semibold,PingFang SC');
        }
      }
      .el-message-box__message {
        p {
          @include fontStyle(13px, 400, #2e2f33, 20px, 'PingFangSC-Semibold,PingFang SC');
        }
      }
      .el-button {
        width: 72px;
        height: 32px;
        border-radius: 20px;
        border: 1px solid rgba(220, 223, 230, 1);
        padding: 0 !important;
        span {
          @include fontStyle(13px, 600, #5e6066, 18px, 'PingFangSC-Semibold,PingFang SC');
        }
        &.el-button--primary {
          background: $normalC;
          border: 1px solid $normalC;
          span {
            color: #ffffff;
          }
          &:hover {
            background: $hoverC;
            border: 1px solid $hoverC;
          }
        }
      }
    }
    .el-message-box__header {
      padding: 30px 40px 0;
    }
    .el-message-box__content {
      padding: 14px 40px 16px;
    }
    .el-message-box__btns {
      padding: 0 40px;
    }
  }
}

.mytask-download-btn {
  &:active {
    background: $normalC;
  }
  &:hover {
    background: $hoverC;
    span {
      color: #ffffff;
    }
  }
}

.mytask-delete-btn {
  &:hover {
    border-color: #c4c6cc;
  }
}
.el-progress-bar__outer {
  background-color: #dcdfe6;
}
</style>
